import React from "react";
import { CheckCircle2, Ticket } from "lucide-react";
import {
  AttendanceGridItem,
} from "@/modules/eventRegistration/features/EventWaitlist/api/fetchEventAttendences/types";
import { WaitlistDetails } from "@/modules/eventRegistration/features/EventWaitlist/api/fetchWaitlistDetails/types";
import AttendanceKanban from "@/modules/eventRegistration/features/EventWaitlist/components/AttendanceKanban/AttendanceKanban";

interface AttendanceProps {
  gridItems: AttendanceGridItem[];
  sessionDays: string[];
  selectedDay: string | null;
  loading: boolean;
  onRefresh?: () => void;
  updateAttendance: (
    attendanceId: number,
    data: { status?: string; notes?: string },
  ) => Promise<void>;
  waitlistDetails: WaitlistDetails | null;
  isSessionFinalized?: boolean;
}

export default function Attendances({
  gridItems,
  selectedDay,
  loading,
  updateAttendance,
  isSessionFinalized,
}: AttendanceProps) {
  if (loading) {
    return (
      <div className="py-8 text-center text-muted-foreground">
        Loading attendance data...
      </div>
    );
  }

  if (gridItems.length === 0) {
    return (
      <div className="py-8 text-center text-muted-foreground">
        No attendance records found.
      </div>
    );
  }

  return (
    <>
      {isSessionFinalized && (
        <div className="mb-4 p-4 bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-md">
          <div className="flex items-center gap-2">
            <div className="flex items-center justify-center w-6 h-6 bg-green-100 dark:bg-green-800/30 rounded-full">
              <CheckCircle2 className="h-4 w-4 text-green-600 dark:text-green-400" />
            </div>
            <div>
              <p className="text-sm font-medium text-green-800 dark:text-green-200">
                Session Finalized
              </p>
              <p className="text-sm text-green-700 dark:text-green-300">
                This session has been finalized. Attendance records are now
                read-only.
              </p>
            </div>
          </div>
        </div>
      )}

      {gridItems.some((item) => item.usedVoucher) && (
        <div className="mb-3 flex items-center gap-1.5 text-xs text-gray-500 dark:text-gray-400">
          <Ticket className="h-3.5 w-3.5 text-green-500 dark:text-green-400" />
          <span>= Voucher attendee</span>
        </div>
      )}

      <AttendanceKanban
        gridItems={gridItems}
        selectedDay={selectedDay}
        updateAttendance={updateAttendance}
        isSessionFinalized={isSessionFinalized}
      />
    </>
  );
}
